/** Read models for the realm viewer - plain data, safe to post between the worker and the page. */

export const ENTITY_TYPE_NAMES: Readonly<Record<string, string>> = {
  PERSON: 'Person',
  PLACE: 'Place',
  FACTION: 'Faction',
  SPECIES: 'Species',
  CREATURE: 'Creature',
  ITEM: 'Item',
  EVENT: 'Event',
  CONCEPT: 'Concept',
  CULTURE: 'Culture',
  TECHNOLOGY: 'Technology',
  RELIGION: 'Religion',
  CUSTOM: 'Custom',
};

export const AUDIENCE_NAMES: Readonly<Record<string, string>> = {
  OWNER: 'Owner',
  EDITOR: 'Editor',
  CONTRIBUTOR: 'Contributor',
  PLAYER: 'Player',
  READER: 'Reader',
  CUSTOM: 'Custom',
};

export interface Audience {
  readonly role: string;
  readonly customLabel: string;
}

export interface RealmCounts {
  readonly entries: number;
  readonly collections: number;
  readonly maps: number;
  readonly timelines: number;
  readonly calendars: number;
  readonly boards: number;
  readonly stories: number;
  readonly campaigns: number;
  readonly sheets: number;
  readonly randomTables: number;
  readonly scripts: number;
}

export interface EntrySummary {
  readonly id: string;
  readonly title: string;
  readonly entityType: string;
  /** What to show for the type: the custom type's own name for a custom entry. */
  readonly typeName: string;
  readonly locked: boolean;
  readonly labels: readonly string[];
  readonly aliases: readonly string[];
}

export interface EntryLinkView {
  readonly entryId: string;
  readonly title: string;
  readonly relationshipType: string;
}

export interface EntryImageView {
  readonly id: string;
  readonly fileName: string;
  readonly mimeType: string;
  readonly data: Uint8Array;
  /** When it was attached, an ISO-8601 instant: kept when an undone removal puts it back. */
  readonly created: string;
}

export interface EntryDetail extends EntrySummary {
  readonly contentHtml: string;
  /** For a locked entry: the desktop-compatible encrypted blob (see contentCipher.ts). */
  readonly encryptedContent: string;
  readonly audience: Audience;
  readonly metadata: readonly (readonly [string, string])[];
  readonly links: readonly EntryLinkView[];
  readonly backlinks: readonly EntryLinkView[];
  readonly collections: readonly string[];
  readonly images: readonly EntryImageView[];
  readonly created: string;
  readonly modified: string;
}

export interface CollectionSummary {
  readonly id: string;
  readonly name: string;
  readonly audience: Audience;
  readonly entryIds: readonly string[];
}
